import { Components } from '@mui/material/styles/components';
import { ControllerStepperColor } from '../../palette';
import theme from '../../provider/controllerBaseTheme';

export const StepperComponent: Components = {
  MuiStep: {
    styleOverrides: {
      root: {},
    },
  },
  MuiStepButton: {
    styleOverrides: {
      root: {},
    },
  },
  MuiStepConnector: {
    styleOverrides: {
      root: {},
    },
  },
  MuiStepContent: {
    styleOverrides: {
      root: {},
    },
  },
  MuiStepIcon: {
    styleOverrides: {
      root: {
        '&.Mui-completed': {
          color: theme.palette.grey[800],
        },
      },
    },
  },
  MuiStepLabel: {
    styleOverrides: {
      root: {
        '& .MuiStepLabel-iconContainer svg': {
          fontSize: '1.25rem',
        },
      },
      label: {
        color: theme.palette.grey[800],
        '&.Mui-active': {
          color: ControllerStepperColor.StepLabelActiveFg,
        },
        '&.Mui-disabled': {
          color: ControllerStepperColor.StepLabelInactiveFg,
        },
        '&.Mui-error': {
          color: ControllerStepperColor.StepLabelErrorFg,
        },
      },
    },
  },
  MuiStepper: {
    styleOverrides: {
      root: {},
    },
  },
};
